module.exports = __webpack_public_path__ + "img/Dash_utilitarios3.4f11d577.svg";